module.exports = __webpack_public_path__ + "media/images/arrow_disable-3fca4e0f1c4f9b429b6dc51912e54b80.png";